import TabFinance from '@/components/comptable/dashboard/tab-finance'
import TabDMP from '@/components/comptable/dashboard/tab-dmp'
// import $ from 'jquery'

export default {
    name: 'dashboard',
    components: {
        TabFinance, TabDMP
    },
    props: [],
    data () {
        return {
            config_to_show: 'finance'
        }
    },

    watch: {
        
    },

    computed: {
        liste_personnel_roles() {
            return this.$store.getters["liste_personnel_roles"];
        },
    },

    mounted () {
        
    },

    methods: {
        changeTab(tab_to_show) {
            this.config_to_show = tab_to_show
        },
    }
}